import { baseUrl } from "../../config.js";
import { errorDispatch } from "../../functions/errorDispatch.js";

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      n_filedownload: null,
      n_transferdownload: null,
      n_fileupload: null,
      n_registration: null,
      n_updates: null,
      company_full: null,
    };
  },
  created() {
    this.$axios.get(baseUrl + "/notifications").then((response) => {
      this.n_filedownload = response.data.n_filedownload;
      this.n_transferdownload = response.data.n_transferdownload;
      this.n_filedownload = response.data.n_filedownload;
      this.n_registration = response.data.n_registration;
      this.n_updates = response.data.n_updates;
      this.n_fileupload = response.data.n_fileupload;
    });

    this.$axios
      .get(baseUrl + "/company?company=" + this.company, {
        responseType: "json",
      })
      .then((response) => {
        this.company_full = response.data;
      })
      .catch((e) => {
        errorDispatch("find_notifications");
      });
  },
  methods: {
    submit(e) {
      e.preventDefault();
      let formData = new FormData();
      formData.append("n_filedownload", this.n_filedownload);
      formData.append("n_transferdownload", this.n_transferdownload);
      formData.append("n_fileupload", this.n_fileupload);
      formData.append("n_registration", this.n_registration);
      formData.append("n_updates", this.n_updates);
      this.$axios
        .post(baseUrl + "/notificationsupdate", formData)
        .then((response) => {
          if (response.data) {
            //this.response.data;
            this.$axios.get(baseUrl + "/notifications").then((response) => {
              this.n_filedownload = response.data.n_filedownload;
              this.n_transferdownload = response.data.n_transferdownload;
              this.n_filedownload = response.data.n_filedownload;
              this.n_registration = response.data.n_registration;
              this.n_updates = response.data.n_updates;
            });
            //this.$router.push("/Noticed");
          } else {
            this.error = "Your credentials do not match our records.";
          }
        })
        .catch((thrown) => {
          this.error = "Something went wrong.";
        });
    },
    goTo(route) {
      this.$router.push(route);
      // this.show = false;
    },
  },
};
